/*eslint-disable*/
import React from 'react'
import PropTypes from 'prop-types'
import Breadcrumbs from '../Breadcrumbs'

const PageHeader = ({
  title = '',
  groupId,
  showBreadCrumbs = false,
  pageName = '',
  edit = false,
  view = false,
  memberActions = false,
}) => {
  return (
    <div
      style={{
        backgroundColor: '#F5F5F5',
        width: '100vw',
        padding: '20px 20px 10px 20px',
        height: '140px',
      }}
    >
      <Breadcrumbs
        value={
          edit || view || memberActions
            ? 'Group / View & Edit'
            : 'Group / Create new'
        }
        extraLinks={
          edit
            ? [
                { label: title, link: `/view-group/${groupId}` },
                { label: 'Edit', link: `/view-group/${groupId}` },
              ]
            : view
            ? [{ label: title, link: '' }]
            : memberActions
            ? [
                { label: title, link: `/view-group/${groupId}` },
                {
                  label: 'View & Edit Members',
                  link: `/view-group/${groupId}`,
                },
              ]
            : []
        }
      />
      {view ||
        (memberActions && (
          <div
            style={{
              paddingLeft: '280px',
              fontSize: '36px',
              paddingBottom: '20px',
              paddingTop: '20px',
            }}
          >
            {title}
          </div>
        ))}
    </div>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string,
  showBreadCrumbs: PropTypes.boolean,
  pageName: PropTypes.string,
  groupId: PropTypes.string,
  edit: PropTypes.boolean,
  view: PropTypes.boolean,
  memberActions: PropTypes.boolean,
}

PageHeader.defaultProps = {
  title: '',
  showBreadCrumbs: false,
  pageName: '',
  groupId: '',
  edit: false,
  view: false,
  memberActions: false,
}

export default PageHeader
